import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import ApiRoutes from "routing/ApiRoutes";
import UserNotification from "util/UserNotification";
import { onError } from "util/conditional/onError";
function fetchScopePermissions() {
  return fetch("GET", qualifyUrl(ApiRoutes.EntityScopeController.getScope().url));
}
const useGetPermissionsByScope = (entity = void 0) => {
  var _a, _b, _c;
  const { data, isLoading } = useQuery({
    queryKey: ["scope-permissions"],
    queryFn: () => onError(fetchScopePermissions(), (e) => UserNotification.error(e.message)),
    retry: 1,
    // cache for 3 hours
    gcTime: 1e3 * 60 * 60 * 3,
    // data is valid for 3 hours
    staleTime: 1e3 * 60 * 60 * 3
  });
  const scope = ((_a = entity == null ? void 0 : entity._scope) == null ? void 0 : _a.toUpperCase()) || "DEFAULT";
  const permissions = (_c = (_b = data == null ? void 0 : data.entity_scopes) == null ? void 0 : _b[scope]) != null ? _c : { is_mutable: false, is_deletable: false };
  return {
    loadingScopePermissions: isLoading,
    scopePermissions: permissions,
    checkPermissions: (inEntity) => {
      var _a2, _b2, _c2, _d;
      const entityScope = ((_a2 = inEntity == null ? void 0 : inEntity._scope) == null ? void 0 : _a2.toUpperCase()) || "DEFAULT";
      return (_d = (_c2 = (_b2 = data == null ? void 0 : data.entity_scopes) == null ? void 0 : _b2[entityScope]) == null ? void 0 : _c2.is_mutable) != null ? _d : false;
    }
  };
};
export default useGetPermissionsByScope;
